module.exports = false;



//////////////////
// WEBPACK FOOTER
// ../~/babel-polyfill/~/core-js/modules/_library.js
// module id = 85
// module chunks = 0